import createLogger from '../common/utils/logger';

const log = createLogger('LTLShipping');

export async function checkLTLForAll(skus, url) {
    if(skus == null){
        log.warn("checkLTLForAll was called with no skus");
    }
    const baseUrl = url!= null? `${url}Shipping/ShippingRulesClient/IsLTL?Sku=`:'https://api.storesupply.com/Shipping/ShippingRulesClient/IsLTL?Sku=';

    const fetchPromises = skus.map(sku =>
        fetch(baseUrl + sku)
            .then(async res => {
                if (!res.ok) {
                    const errorText = await res.text();
                    throw new Error(`HTTP ${res.status}: ${errorText}`);
                }

                const contentType = res.headers.get("content-type");
                if (contentType?.includes("application/json")) {
                    return res.json();
                } else {
                    const text = await res.text();
                    throw new Error(`Unexpected content-type: ${contentType}. Body: ${text}`);
                }
            })
    );

    const results = await Promise.allSettled(fetchPromises);

    for (let i = 0; i < results.length; i++) {
        const result = results[i];
        if (result.status === "fulfilled") {
          //console.debug(`✅ [${baseUrl}${skus[i]}] succeeded with response:`, result.value);
            const { Success, Result } = result.value;
            if (Success && Result === true) {
                return true; // At least one item requires LTL
            }
            if(Success === false){
                log.warn(`LTL check failed for SKU [${skus[i]}]:`);
                return true;
            }
        } else {
            log.warn(`LTL check failed for SKU [${skus[i]}]:`, result.reason);
            return true; // Treat error as requiring LTL
        }
    }

    return false; // All SKUs do not require LTL
}